import _to from './to';

export class Map {
  static to = _to;
}

export type { Types } from './types';